export default __webpack_public_path__ + "static/media/gilad_katan.8f4f1d7a.png";